import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourAscent from "./sections/StartYourAscent";
import PrequalifyForFinancing from "./sections/PrequalifyForFinancing";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourAscent />
      <PrequalifyForFinancing />
      <Footer />
    </div>;
}